import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const canny = defineConnector({
  identifier: "canny",
  name: "Canny",
  tagLine: "Feature request tracking",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://canny\\.io/api/v1/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Find your Canny API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In your [Canny](https://canny.io/) account, go to **Settings > API & Webhooks** and copy your API key.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your Canny account settings.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          placeholder: "a1f5937c-82df-bd29-4e3a-7b6fda8c54d1",
          helperText: "The API key for your Canny account",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://canny.io/api/v1/boards/list",
  },
});
